

import { Component, Mixins, Prop } from "vue-property-decorator";
import IBFileListItem from "@/components/IBFile/IBFileListItem.vue";
import { FileListItem } from "@/components/IBFile/interface";
import IBPaymentCardActionCaller from "@/components/IBPayment/mixins/IBPaymentCardActionCaller";

@Component({
	components: {
		IBFileListItem
	}
})
export default class IBFileDownload extends Mixins(IBPaymentCardActionCaller) {

	@Prop({ type: Array, default: () => [] })
	readonly files!: FileListItem[]

	downloadFile(files: FileListItem[]) {
		files.forEach(fileItem => this.callAction(fileItem?.download));
	}

}

